/* @flow */
export const GAME_SCREEN: string = 'gameScreen';
export const EMAIL_AUTH: string = 'emailAuth';
export const SAVE_SCENE: string = 'SAVE_SCENE';
export const CONVERSATION_SCREEN: string = 'conversationScreen';
